var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fillable",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.122 2H2V16.878C2 18.581 3.34255 19.9704 5.02698 20.0456C5.3445 21.1733 6.38034 22 7.60976 22C8.83801 22 9.87305 21.1749 10.1916 20.0488H12.2439V18.5854H10.1916C9.87305 17.4593 8.83801 16.6341 7.60976 16.6341C6.3836 16.6341 5.34999 17.4565 5.02952 18.5796C4.15266 18.5078 3.46341 17.7734 3.46341 16.878V3.46341H15.6585V15.1707H17.122V10.7016L18.8727 11.379C19.8241 11.7471 20.5366 12.6249 20.5366 13.4634V20.0488H22V13.3891C22 11.9182 21.0063 10.6097 19.5057 10.0291L17.122 9.10672V2ZM16.3902 16.6341C14.9085 16.6341 13.7073 17.8353 13.7073 19.3171C13.7073 20.7988 14.9085 22 16.3902 22C17.872 22 19.0732 20.7988 19.0732 19.3171C19.0732 17.8353 17.872 16.6341 16.3902 16.6341ZM6.39024 19.3171C6.39024 18.6436 6.93624 18.0976 7.60976 18.0976C8.28327 18.0976 8.82927 18.6436 8.82927 19.3171C8.82927 19.9906 8.28327 20.5366 7.60976 20.5366C6.93624 20.5366 6.39024 19.9906 6.39024 19.3171ZM15.1707 19.3171C15.1707 18.6436 15.7167 18.0976 16.3902 18.0976C17.0638 18.0976 17.6098 18.6436 17.6098 19.3171C17.6098 19.9906 17.0638 20.5366 16.3902 20.5366C15.7167 20.5366 15.1707 19.9906 15.1707 19.3171Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truckIcon.1c823eb57e1046eb3d79de6c7a92cf3a.svg";
export { ForwardRef as ReactComponent };